import * as angular from 'angular';
import {IQService, IRootScopeService, ITimeoutService, IWindowService} from "angular";
import {SpinnerService} from "./SpinnerModule";
import {ConfigService} from "./ConfigModule";
import {DataHub} from "./DataHub";
import {IToasterService} from "ngtoaster";


export class DataHubService extends DataHub {
    private serverVersion: string;

    constructor($q: IQService,
                $rootScope: IRootScopeService,
                $timeout: ITimeoutService,
                $window: IWindowService,
                $spinner: SpinnerService,
                $config: ConfigService,
                private toaster: IToasterService) {
        super($q, $rootScope, $timeout, $window, $spinner, $config, $config.devMode);

        this.onServerVersion(v=> this.serverVersion=v);

        this.start();

        console.debug(this.toaster)
        this.toaster.pop({
            type:'info',
            body: 'hello',
        toastId:'fart'});
    }


    defaultErrorHandler = (reason: any) => {
        console.error(reason);
        let msg = reason.data?.exceptionMessage || reason.data?.message || reason;
        this.toaster.error({
            body: msg
        });
    }

    // convenience fields for legacy code
    /**
     * @deprecated use new style
     */
    get client() {return this;}
    /**
     * @deprecated use new style
     */
    get server() {return this;}
}

export default angular.module('services.dataHub', [])
    .service('$dataHub', DataHubService)
    .name;
